/**
 * @description: 寄存设置
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="store-set-deposit">
        <!-- 取酒判断包厢是否消费中 -->
        <div class="store-qbx-set" v-show="show1">
            <div class="qbx-list">
                <h1 class="title">取酒判断包厢是否消费中</h1>
                <p class="p-hint">注：【是】包厢状态是消费中才允许取酒。【否】包厢状态不是消费中也允许取酒。<br />消费中的包厢取酒成功就在账单中显示取酒商品。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="qbxList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(1)">返回</button>
                </div>
            </div>
        </div>


        <!-- 过期酒水自动充公设置 -->
        <div class="store-gjc-set" v-show="show2">
            <div class="gjc-list">
                <div class="row rowmagin">
                    <button type="button" class="btn bg-orange btn-flat bigbtn" @click="addGjc">新增设置</button>
                </div>
                <h1 class="title">过期酒水自动充公设置</h1>
                <p class="p-hint">注：到期天数必填，到期后的天数为0则到期后立即自动充公。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="gjcList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(2)">返回</button>
                </div>
            </div>
            <!-- 新增、修改 -->
            <div class="gjc-edit" ref="gjc_edit">
                <div class="row">
                    <label class="col-md-3">门店：</label>
                    <div class="col-md-9 ct-col">
                        <select class="form-control" ref="gjc_shop"></select>
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-3">自动充公时间：</label>
                    <div class="col-md-9">
                        到期 <input class="form-control" placeholder="请输入数字" v-model="gjc_num"> 天后自动充公
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-3">充公仓库：</label>
                    <div class="col-md-9 ct-col">
                        <select class="form-control" ref="gjc_store"></select>
                    </div>
                </div>
            </div>
        </div>


        <!-- 智慧商家app寄存酒手机号是否必填 -->
        <div class="store-jcp-set" v-show="show3">
            <div class="jcp-list">
                <h1 class="title">app新增存酒单必填项设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="jcpList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(3)">返回</button>
                </div>
            </div>
        </div>


        <!-- 寄存酒即将到期消息提醒设置 -->
        <div class="store-gxt-set" v-show="show4">
            <div class="gxt-list">
                <h1 class="title">寄存酒即将到期消息提醒设置</h1>
                <div class="red-tip">
                    <p>注：1 设置提醒时间后，符合设置时间时，微信公众号消息和短信消息会给存酒用户发送消息提醒</p>
                    <p>2 提醒时间设置为0时，即到期当天发送消息提醒</p>
                    <p>3 短信通知时间为10：00-24：00期间，若到期时间为00：00-10：00期间的，系统将统一到10：00后发送短信通</p>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="gxtList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(4)">返回</button>
                </div>
            </div>
            <div class="sms-set-pop" ref="sms_set_pop">
                <div class="params-txt">系统变量：【门店名称】【剩余天数】【到期时间】【酒水详情】</div>
                <div class="sms-content">
                    <p>尊敬的vip，您在<el-input placeholder="【门店名称】" v-model="sms_params.shop_name" clearable></el-input></p>
                    <p>寄存的酒水还有<el-input placeholder="【剩余天数】" v-model="sms_params.day" clearable></el-input>有效期，</p>
                    <p>有效期至：<el-input placeholder="【到期时间】" v-model="sms_params.date" clearable></el-input></p>
                    <p>酒水详情：<el-input placeholder="【酒水详情】" v-model="sms_params.goods" clearable></el-input></p>
                </div>
            </div>
        </div>


        <!-- 取酒是否支持修改取酒数量 -->
        <div class="store-qzx-set" v-show="show5">
            <div class="qzx-list">
                <h1 class="title">取酒是否支持修改取酒数量</h1>
                <p class="p-hint">注：【否】取酒时不支持修改取酒数量，【是】取酒时支持修改取酒数量</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="qzxList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(5)">返回</button>
                </div>
            </div>
        </div>


        <!-- 是否支持微信自助存取酒 -->
        <div class="store-wzc-set" v-show="show6">
            <div class="wzc-list">
                <h1 class="title">是否支持微信自助存取酒</h1>
                <table class="table table-bordered table-hover" data-pagination="true" ref="wzcList"></table>
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(6)">返回</button>
            </div>
        </div>

        <!-- 微信端存酒单显示设置 -->
        <div class="store-wcdx-set" v-show="show7">
            <div class="wcdx-list">
                <h1 class="title">微信端存酒单显示设置</h1>
                <p class="p-hint">注：关闭后，微信端不显示对应状态下的存酒单</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="wcdxList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(7)">返回</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'store_set_deposit',
        data() {
            return {
                show1: false,
                show2: false,
                show3: false,
                show4: false,
                show5: false,
                show6: false,
                show7: false,

                // 过期酒水自动充公设置
                gjc_modify: '1',
                gjc_num: '0',
                sms_params: {
                    shop_name: '',
                    day: '',
                    date: '',
                    goods: '',
                },
            }
        },
        watch: {

        },
        mounted: function() {

        },
        methods: {
            // 显示页面
            showTargetPage(num) {
                this[`show${num}`] = true

                if(num == '1') {
                    this.innitQbxTable()
                } else if(num == '2') {
                    this.innitGjcTable()
                    this.getShopData()
                } else if(num == '3') {
                    this.innitJcpTable()
                } else if(num == '4') {
                    this.innitGxtTable()
                } else if(num == '5') {
                    this.innitQzxTable()
                } else if(num == '6') {
                    this.innitWzcTable()
                } else if (num == '7') {
                    this.innitWcdxTable()
                }
            },
            // 返回
            backIndex(index) {
                this[`show${index}`] = false
                this.$emit('targetBack')
            },


            /*
             * 取酒判断包厢是否消费中
             */
            // 初始化取酒判断包厢是否消费中
            innitQbxTable: function() {
                let _this = this;
                $(_this.$refs.qbxList).bootstrapTable('destroy');
                $(_this.$refs.qbxList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.geQbxList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "bill_include_deposit",
                        title: "取酒判断包厢是否消费中",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.qbxSub(row.id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.bill_include_deposit == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 取酒判断包厢是否消费中列表
            geQbxList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getShopConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 取酒判断包厢是否消费中设置
            qbxSub: function(id, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "bill_include_deposit": check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/setShopConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.qbxList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 过期酒水自动充公设置
             */
            // 获取门店数据
            getShopData: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            arr.shift();

                            $(_this.$refs.gjc_shop).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                _this.getGjcStore(e.params.data.id);
                            });
                            _this.getGjcStore($(_this.$refs.gjc_shop).val());
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 获取门店下仓库
            getGjcStore: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getStoreList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.gjc_store).html('');
                            $(_this.$refs.gjc_store).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            innitGjcTable: function() {
                let _this = this;
                $(_this.$refs.gjcList).bootstrapTable('destroy');
                $(_this.$refs.gjcList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getGjcList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "expire_str",
                        title: "到期后自动充公时间",
                        width: "20%"
                    }, {
                        field: "store_name",
                        title: "充公仓库",
                        width: "20%"
                    }, {
                        field: "op",
                        title: "操作",
                        width: "30%",
                        events: {
                            'click .edit': function(e, value, row) {
                                _this.gjc_modify = '2';
                                $(_this.$refs.gjc_shop).prop('disabled', true);
                                $(_this.$refs.gjc_shop).val(row.shop_id).trigger('change');
                                _this.getGjcStore(row.shop_id);
                                $(_this.$refs.gjc_store).val(row.store_id).trigger('change');
                                _this.gjc_num = row.expire_date;
                                _this.editGjc('修改设置', row.id)
                            },
                            'click .del': function(e, value, row) {
                                layer.confirm('删除后不可恢复，确定删除吗？', {
                                    btn: ['确定', '取消']
                                }, function() {
                                    _this.delGjc(row.id);
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue edit">修改</span>&nbsp;&nbsp;&nbsp;<span class="text-blue del">删除</span>'
                        }
                    }]
                });
            },
            // 列表
            getGjcList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Deposit/getConfiscateSetList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 点击新增
            addGjc: function() {
                this.gjc_modify = '1';
                $(this.$refs.gjc_shop).prop('disabled', false);
                $(this.$refs.gjc_shop).val('').trigger('change');
                this.getGjcStore($(this.$refs.gjc_shop).val());
                $(this.$refs.gjc_store).val('').trigger('change');
                this.gjc_num = '0';
                this.editGjc('新增设置', '');
            },
            editGjc: function(name, id) {
                let _this = this;
                layer.confirm('', {
                    skin: 'add_goods-alert',
                    type: 1,
                    btn: ['确定', '取消'],
                    title: [name, true],
                    area: ['660px', ''],
                    content: $(_this.$refs.gjc_edit),
                    offset: '100px'
                }, function() {
                    let url = Vue.ctUrl + "Deposit/addConfiscateSet";
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": $(_this.$refs.gjc_shop).val(),
                                "store_id": $(_this.$refs.gjc_store).val(),
                                "expire_date": _this.gjc_num
                            }
                        },
                        "comment": ""
                    };
                    if(_this.gjc_modify == '2') {
                        url = Vue.ctUrl + "Deposit/editConfiscateSet";
                        datas["request"]["param"]["id"] = id;
                    }
                    let datas2 = JSON.stringify(datas);
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        url: url,
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: {
                            json: datas2
                        },
                        success: function(data) {
                            if(data.response.result_code == "true") {
                                layer.closeAll();
                                layer.msg(data.response.error_msg);
                                $(_this.$refs.gjcList).bootstrapTable("refresh");
                            } else {
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data.response.error_msg);
                            }
                        },
                        error: function(err) {
                            layer.msg("出错啦");
                        }
                    });
                });
            },
            // 删除
            delGjc: function(id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Deposit/delConfiscateSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('删除成功');
                            $(_this.$refs.gjcList).bootstrapTable("refresh");
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * app新增存酒单必填项设置
             */
            innitJcpTable: function() {
                let _this = this;
                $(_this.$refs.jcpList).bootstrapTable('destroy');
                $(_this.$refs.jcpList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.geJcpList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "序号",
                        width: "10%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "25%"
                    }, {
                        field: "deposit_required_mobile",
                        title: "手机号是否必填",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.jcpSub(row.id, 'deposit_required_mobile', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.deposit_required_mobile == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "deposit_required_user",
                        title: "姓名是否必填",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.jcpSub(row.id, 'deposit_required_user', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.deposit_required_user == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "deposit_required_remark",
                        title: "备注是否必填",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.jcpSub(row.id, 'deposit_required_remark', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.deposit_required_remark == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            geJcpList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getShopConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            jcpSub: function(id, key, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            [key]: check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/setShopConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.jcpList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 即将过期微信消息提醒时间设置
             */
            innitGxtTable: function() {
                let _this = this;
                $(_this.$refs.gxtList).bootstrapTable('destroy');
                $(_this.$refs.gxtList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getGxtList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "25%"
                    }, {
                        field: "deposit_almost_expire_days",
                        title: "即将过期微信消息<br />提醒时间设置（第一次）",
                        width: "25%",
                        events: {
                            'blur .input-val': function(e, value, row) {
                                if($.trim($(this).val()) < 0) {
                                    layer.msg('不能设置负数');
                                    $(_this.$refs.gxtList).bootstrapTable('refresh');
                                } else {
                                    _this.gxtSub(row.id, $.trim($(this).val()), '1');
                                }
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<input type="text" class="input-val" value="'+ value +'" />' + '天';
                        }
                    }, {
                        field: "deposit_expire_days",
                        title: "即将过期微信消息<br />提醒时间设置（第二次）",
                        width: "25%",
                        events: {
                            'blur .input-val': function(e, value, row) {
                                if($.trim($(this).val()) < 0) {
                                    layer.msg('不能设置负数');
                                    $(_this.$refs.gxtList).bootstrapTable('refresh');
                                } else {
                                    _this.gxtSub(row.id, $.trim($(this).val()), '2');
                                }
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<input type="text" class="input-val" value="'+ value +'" />' + '天';
                        }
                    },{
                        field: "op",
                        title: "操作",
                        width: "25%",
                        events: {
                            'click .edit': function(e, value, row) {
                                console.log(row)
                                _this.openSmsSetPop(row)
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue edit">短信模板设置</span>'
                        }
                    }]
                });
            },
            // 列表
            getGxtList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Setting/getShopConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            gxtSub: function(id, input_val, type) {
                const _this = this;

                let param = {};
                if(type == '1') {
                    param = {
                        "id": id,
                        "deposit_almost_expire_days": input_val
                    };
                } else {
                    param = {
                        "id": id,
                        "deposit_expire_days": input_val
                    };
                }
                Vue.axios.post('Setting/setShopConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": param
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.gxtList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            openSmsSetPop: function(row) {
                let _this = this;
                _this.sms_params = {
                    shop_name: row.deposit_expire_sms[0],
                    day: row.deposit_expire_sms[1],
                    date: row.deposit_expire_sms[2],
                    goods: row.deposit_expire_sms[3],
                }

                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'],
                    title: ['短信模板设置', true],
                    area: ['600px', '500px'],
                    content: $(_this.$refs.sms_set_pop),
                    offset: '100px'
                }, function() {
                    let config = Object.values(_this.sms_params)
                    Vue.axios.post('Shop/upConfig', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "id": row.shop_id,
                                "config_type": 'deposit_expire_sms',
                                "config": config
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg('设置成功');
                            $(_this.$refs.gxtList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
                });
            },


            /*
             * 取酒是否支持修改取酒数量
             */
            innitQzxTable: function() {
                let _this = this;
                $(_this.$refs.qzxList).bootstrapTable('destroy');
                $(_this.$refs.qzxList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getQzxList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "app_depost_change_goods_num",
                        title: "APP端员工取酒",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.qzxSub(row.shop_id, check_stock, 'app_depost_change_goods_num');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "wx_depost_change_goods_num",
                        title: "微信自助取酒",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.qzxSub(row.shop_id, check_stock, 'wx_depost_change_goods_num');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getQzxList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Shop/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": 'depost_change_goods_num'
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            qzxSub: function(id, check_stock, config_type) {
                const _this = this;

                Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config_type": config_type,
                            "config": check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.qzxList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 是否支持微信自助存取酒
             */
            innitWzcTable: function() {
                let _this = this;
                $(_this.$refs.wzcList).bootstrapTable('destroy');
                $(_this.$refs.wzcList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getWzcList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "self_help_deposit",
                        title: "是否支持微信自助存取酒",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.wzcSub(row.shop_id, 'self_help_deposit', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "cross_self_help_deposit",
                        title: "是否支持微信跨门店取酒",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.wzcSub(row.shop_id, 'cross_self_help_deposit', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            let disabled = row.self_help_deposit == '-1' ? 'disabled' : ''
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select' "+ disabled + "><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select' "+ disabled + "><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getWzcList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Shop/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": 'self_help_deposit'
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            wzcSub: function(id, key, check_stock) {
                const _this = this;

                Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config_type": key,
                            "config": check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.wzcList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            /*
             * 微信端存酒单显示设置
             */
            // 初始化微信端存酒单显示设置列表
            innitWcdxTable: function() {
                let _this = this;
                $(_this.$refs.wcdxList).bootstrapTable('destroy');
                $(_this.$refs.wcdxList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.commonGetConfigList(params, 'deposit_show_setting');
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "taken_deposit_show",
                        title: "已取的存酒单是否显示",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.commonConfigSet(row.shop_id, 'taken_deposit_show', check_stock, 'wcdxList');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.taken_deposit_show == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "expired_deposit_show",
                        title: "过期的存酒单是否显示",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.commonConfigSet(row.shop_id, 'expired_deposit_show', check_stock, 'wcdxList');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.expired_deposit_show == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },

            // 通用设置列表
            commonGetConfigList(params, config_type) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": config_type
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 通用设置
            commonConfigSet(id, config_type, check_stock, ref) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config_type": config_type,
                            "config": check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('设置成功');
                            $(_this.$refs[`${ref}`]).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    // 过期酒水自动充公设置
    .store-gjc-set {
        .gjc-edit {
            display: none;
            label {
                padding: 0;
                line-height: 32px;
                color: #5e5e5e;
                font-size: 14px;
                text-align: right;
                font-weight: normal;
            }
            .row {
                margin: 0 0 20px;
            }
            div {
                font-size: 14px;
            }
            input {
                display: inline-block;
                width: 100px;
                margin: 0 10px;
            }
        }
    }
    .store-gxt-set {
        .red-tip {
            color: red;
        }
        .sms-set-pop {
            display: none;
            .sms-content {
                margin-top: 20px;
                padding: 20px;
                background: #efefef;
                .el-input {
                    width: 320px;
                    margin: 0 5px;
                    margin-bottom: 10px;
                }
            }
        }
    }
</style>